import { NgModule, ModuleWithProviders, Type } from '@angular/core';

import { DynamicFormCommonModule, DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { DynamicFormDesignerModule, DynamicFormDesignerConfig } from 'zr-dynamic-form/dynamic-form-designer';
import { DynamicFormDesigntimeModule, DynamicFormDesignTimeConfig } from 'zr-dynamic-form/dynamic-form-designtime';
import { DynamicFormRuntimeModule, DynamicFormRuntimeConfig } from 'zr-dynamic-form/dynamic-form-runtime';
import { DynamicFormConfig } from './utils/dynamic-form-config';
import { DynamicFormDynamicPageModule } from 'zr-dynamic-form/dynamic-form-dynamic-page';

export * from 'zr-dynamic-form/dynamic-form-common';
export * from 'zr-dynamic-form/dynamic-form-designer';
export * from 'zr-dynamic-form/dynamic-form-designtime';
export * from 'zr-dynamic-form/dynamic-form-runtime';
export * from 'zr-dynamic-form/dynamic-form-dynamic-page';
@NgModule({
  declarations: [],
  imports: [],
  exports: [
    DynamicFormCommonModule,
    DynamicFormDesignerModule,
    DynamicFormDesigntimeModule,
    DynamicFormRuntimeModule,
    DynamicFormDynamicPageModule
  ]
})
export class ZrDynamicFormModule {
  static forRoot(config: DynamicFormConfig): ModuleWithProviders {
    return {
      ngModule: ZrDynamicFormModule,
      providers: [
        { provide: DynamicFormCommonConfig, useClass: config.FormCommonConfig },
        { provide: DynamicFormDesignerConfig, useClass: config.FormDesignerConfig },
        { provide: DynamicFormDesignTimeConfig, useClass: config.FormDesignTimeConfig },
        { provide: DynamicFormRuntimeConfig, useClass: config.FormRuntimeConfig }
      ]
    };
  }
}
